export { default as Templates } from './Templates'
export { default as Template } from './Template'
export { default as TemplateEditor } from './TemplateEditor'
export { default as Submenu } from './Submenu'



// WEBPACK FOOTER //
// ./scripts/components/views/templates/index.js